import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api, homeFor } from "../lib/api";
import { FullLoader } from "../components/Guards";

export default function AuthCallback() {
  const processed = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/google", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        const pending = sessionStorage.getItem("ar_pending_tier");
        sessionStorage.removeItem("ar_pending_tier");
        const dest = !data.tier && data.role !== "admin" && pending ? `/join?tier=${pending}` : homeFor(data);
        navigate(dest, { replace: true });
      })
      .catch(() => {
        setUser(false);
        navigate("/auth", { replace: true });
      });
  }, [location.hash, navigate, setUser]);

  return <FullLoader />;
}
